// Shared color and layout tokens for the Territory Overview card and its sub-components.

export const TRACK_BG = "#F1F1F1";
export const PRIMARY_BLUE = "#396D87";
export const MUTED = "#6B7280";
export const BODY = "#2D2D2D";
export const BORDER = "#E5E5E5";

/** Light blue/teal tokens for the "Your input" badge. */
export const INPUT_BADGE_BG = "#E6F0F4";
export const INPUT_BADGE_TEXT = "#396D87";

// Breadth vs. Depth Summary uses this fixed panel height so it stays visually aligned next to the variable-height Referrals/Active Patients panels.
export const TWO_BAR_PANEL_HEIGHT = 222;

// Referrals QTD and Active Patients QTD hold at least this height so they stay consistent — including their empty "No insights found" states, where the content would otherwise collapse the panel. Richer data (e.g. multiple attainment bars) can still grow a panel past this, since it is a floor, not a cap.
export const LEFT_PANEL_MIN_HEIGHT = 200;
